import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-gestione-amministrativa-view',
  templateUrl: './form-gestione-amministrativa-view.component.html',
  styleUrls: ['./form-gestione-amministrativa-view.component.css']
})
export class FormGestioneAmministrativaViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
